// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jy-0";